module.exports = __webpack_public_path__ + "img/article_b.8f51e1ae.png";